var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('section1'),_c('section2'),_c('section3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }